export default "__VITE_ASSET__DlooEO87__"